(function($){

    $('body').on('change', '.shortcode-variations select', function(){
        load_wds_variants();
    });
    $('body').on('click', '.wds-variants .options span:not(.inactive)', function(){
        var val = $(this).attr('data-value');
        var woo_select_id = $(this).closest('.options').attr('data-name');
        $('#' + woo_select_id).val(val).trigger('change');
    })
    if($('.wds-variants').length > 0){
        setInterval(function(){
            if($('.my-product-shortcode .single_variation').html() != ''){
                $('.my-product-shortcode .variations_button').css('display', 'flex');
            }
            else{
                $('.my-product-shortcode .variations_button').css('display', 'none');
            }
        }, 1000)
    }

    load_wds_variants();
    function load_wds_variants(){
        if($('.wds-variants').length > 0){
            var name;
            $('.wds-variants').closest('.options').find('.active').removeClass('active');
            $('.wds-variants .variations select').each(function(){
                name = $(this).attr('id');
                $('.wds-variants').find('[data-name="'+name+'"]').html('');
                $(this).find('option').each(function(){
                    if($(this).attr('value') != ''){
                        $('.wds-variants').find('[data-name="'+name+'"]').append('<span data-value="'+$(this).attr('value')+'">'+$(this).attr('value')+'</span>');
                    }
                })
                $('.wds-variants').find('[data-name="'+name+'"] [data-value="'+$(this).val()+'"]').addClass('active');
                var i;
                for(i = 1; i < 6; i++){
                    if($('.wds-variants [data-name="ilosc-doroslych"] span[data-value="'+i+'"]').length <= 0){
                        if($('.wds-variants [data-name="ilosc-doroslych"] span.inactive[data-value="'+i+'"]').length <= 0){
                            $('.wds-variants [data-name="ilosc-doroslych"]').append('<span data-value="'+i+'" class="inactive">'+i+'</span>');
                        }
                    }
                }
                for(i = 0; i < 5; i++){
                    if($('.wds-variants [data-name="ilosc-dzieci"] span[data-value="'+i+'"]').length <= 0){
                        if($('.wds-variants [data-name="ilosc-dzieci"] span.inactive[data-value="'+i+'"]').length <= 0){
                            $('.wds-variants [data-name="ilosc-dzieci"]').append('<span data-value="'+i+'" class="inactive">'+i+'</span>');
                        }
                    }
                }
            })
        }
    }
})(jQuery)